import axios from 'axios';
import axiosGoongMap from './setup/axiosGoongMap';
import { get } from 'http';

const GoongMapApi = {
  getPlacesSearchBykeyword: async (params: { input: string; limit?: any }) => {
    params.limit = params.limit || 5;
    return await axiosGoongMap.get(`/v2/place/autocomplete`, {
      params: {
        api_key: process.env.REACT_APP_GOONG_API_KEY,
        more_compound: true,
        ...params,
      },
    });
  },

  getPlaceDetailById: async (placeId: string) => {
    return await axiosGoongMap.get(`/v2/place/detail`, {
      params: {
        place_id: placeId,
        api_key: process.env.REACT_APP_GOONG_API_KEY,
      },
    });
  },
  getReverseGeocoding: async (params: { lat: number; lng: number }) => {
    return await axiosGoongMap.get(`/v2/geocode`, {
      params: {
        api_key: process.env.REACT_APP_GOONG_API_KEY,
        latlng: `${params.lat}, ${params.lng}`,
      },
    });
  },

  getDistanceMatrix: async (params: {
    origins: { lat: number; lng: number };
    destinations: [{ lat: number; lng: number }];
    vehicle: 'car' | 'bike' | 'taxi' | 'truck' | 'hd';
    [key: string]: any;
  }): Promise<any> => {
    try {
      return await axiosGoongMap.get(`/v2/distance-matrix`, {
        params: {
          api_key: process.env.REACT_APP_GOONG_API_KEY, // Required
          origins: `${params.origins.lat}, ${params.origins.lng}`,
          destinations: params.destinations
            .map((item: any) => `${item.lat}, ${item.lng}`)
            .join('|'),
          vehicle: params.vehicle || 'car',
        },
      });
    } catch (e) {
      console.log(e);
      return {
        rows: [],
      };
    }
  },
};

export default GoongMapApi;
